































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Api from '@/common/api';

import * as PleasedModel from '@/common/api/models.pleased';
import { TransactionStatus, TransactionType } from '@/common/config';
import Input from '@/components/Input.vue';
import { Button, BottomWrapper } from '../BottomWrapper.vue';
import LoginGuest from './LoginGuest.vue';
import GuestForm from './GuestForm/GuestForm.vue';
import Transaction from './Transaction/Transaction.vue';
import BetTransaction from './Transaction/BetTransaction.vue';
import LoggedInForm from './LoggedInForm/LoggedInForm.vue';
import ContactOptions from './ContactOptions.vue';
import { namespace } from 'vuex-class';
import { emitOpenMyRequest } from '@/common/eventBus';
import waiting from '@/components/loading/waiting';
import { listenFromParent } from '@/common/bridge';
import { FormField, ConnectRequestEvent, TransactionInputEvent, VisitorInfoFilled, DynamicFieldData, RemedyTransactionInputEvent } from '@/common/types';
import { ApplyMetadataAutomationExternEvent, ConnectToAgent } from '@/common/bot/types';
import TbTrashXIcon from '@/components/icons/TbTrashXIcon.vue';
import { ExternalTransactionKind } from '@/common/bot/enum/ExternalTransactionType';
import { switcher } from '@/common/bot/flow-frameworks/switcher';
import { Conversation } from '../active-conversations/type';
import { MatchedChatTrigger } from '@/common/bot/flow-frameworks/chat-trigger';
import { mixins } from 'vue-class-component';
import LogPageEventMixin, { PAGE_EVENTS, PAGE_TRACKING } from '@/mixins/logPageEvent';

const userModule = namespace('user');

export enum StepRoute {
  EndChat, // help_Chat-10
  LoginGuest, // help_Chat-6
  GuestForm, // help_Chat-open ticket without login
  // Login, // help_Chat-7
  Transaction, // help_Chat-8
  LoggedInForm, // help_Chat-8a
  ContactOptions, // help_Chat-9
  OpenRequestEnd
}

export interface StepChangeEvent {
  step: StepRoute,
  previous: StepRoute
}

interface SavedDataToPass {
  transactions: TransactionInputEvent | null
  guest: VisitorInfoFilled | null
  loggedInForm: VisitorInfoFilled | null
}

enum buttonKeyMap {
  Yes = 'yes',
  No = 'no',
  End = 'end',
  // Login = 'login'
};

const buttonMaker = (name: string, id = name): Button => ({ name, id, isActive: true });

@Component({
  components: {
    BottomWrapper,
    Input,
    LoginGuest,
    GuestForm,
    // Login,
    Transaction,
    LoggedInForm,
    ContactOptions,
    BetTransaction,
    TbTrashXIcon,
  },
  directives: {
    waiting,
  },
})
export default class RuleENgineHelper extends mixins(LogPageEventMixin) {
  @Prop() readonly actionableItemKey!: number;
  @Prop() readonly showLoggedInOptions!: { showCall: boolean, showLiveChat: boolean, showOpenRequest: boolean };
  @Prop({ default: false }) readonly isGuestAllowed!: boolean;
  @Prop({ default: '' }) readonly issueMsg!: '';
  @Prop({ default: '' }) readonly ticketSubject!: string;
  @Prop(Boolean) readonly fromActiveConversation!: boolean;
  @Prop() readonly connectConfig!: ConnectToAgent | null;
  @Prop() readonly userSelections!: PleasedModel.UserSelection[];
  @Prop() readonly showThresholdLimitModal!: boolean;
  @Prop() readonly activeConversationTicket!: Conversation;

  @userModule.State('isLogin') isLogin!: boolean;
  @userModule.Mutation('updateLoginStatus') updateLoginStatus!: Function;

  StepRoute = StepRoute;

  get buttonMap (): {[index: number]: Button[]} {
    return {
      [StepRoute.EndChat]: [buttonMaker(this.$t('global.end_chat') as string)],
      // [StepRoute.LoginGuest]: [],
      [StepRoute.OpenRequestEnd]: [buttonMaker(this.$t('global.end_chat') as string, buttonKeyMap.End)] };
  };
  actionMap = {
    [StepRoute.EndChat]: this.endChat,
    // [StepRoute.LoginGuest]: this.handleLoginGuest,
    [StepRoute.GuestForm]: () => {},
    [StepRoute.Transaction]: () => {},
    [StepRoute.OpenRequestEnd]: this.handleLoggedInRequestEnd,
  }
  currentStep: StepRoute | null = null;
  prevStep: StepRoute | null = null;

  savedDataToPass: SavedDataToPass = {
    transactions: null,
    guest: null,
    loggedInForm: null,
  }

  loading = false;
  // Transactions
  actionType: TransactionType | null = null;
  fieldData: DynamicFieldData | null = null;
  guestDescription = '';
  requestInfo: { subject: string, description: string, email: string } = { subject: '', description: '', email: '' }

  get staticFormFields (): FormField[] {
    return [
      {
        id: -10000,
        displayName: 'Description',
        placeholder: 'Describe your problem',
        name: 'description',
        required: true,
      }, {
        id: -10001,
        displayName: 'Subject',
        placeholder: 'Subject',
        name: 'subject',
        required: false,
      },
    ];
  }

  get [PAGE_TRACKING] () {
    if (this.fromActiveConversation) {
      return null;
    }

    return {
      name: PAGE_EVENTS.CONNECT_REQUEST,
    };
  }

  apiFormFields: FormField[] = [];

  get bottomWrapperHandler () {
    const { actionMap, currentStep } = this;
    return actionMap[currentStep as keyof typeof actionMap] || (() => {});
  }

  get allFormFields (): FormField[] {
    return [...this.staticFormFields, ...this.apiFormFields];
  }

  get ticketFields (): PleasedModel.TicketField[] {
    return this.fieldData && this.fieldData.fields ? this.fieldData.fields.filter(f => f.id > 0).map(f => ({ fieldId: f.id, fieldValue: f.value })) : [];
  }

  get externalTransactionKinds () {
    // Handle case with outdated field
    if (!this.connectConfig?.transactionTypes?.length && this.connectConfig?.transactionType) {
      return [this.connectConfig.transactionType];
    }

    return this.connectConfig?.transactionTypes || [];
  }

  get appliedMetadataAutomation () {
    return this.connectConfig?.appliedMetadataAutomation;
  }

  get showContactOptionsBackButton () {
    return !this.fromActiveConversation && this.connectConfig?.showDescriptionBox;
  }

  created () {
    // this.actionType = this.actionableItemKey === 1 ? TransactionType.Deposit
    //   : this.actionableItemKey === 2 ? TransactionType.Withdrawal
    //     : this.actionableItemKey === 3 ? TransactionType.Bet : null;
    const { externalTransactionKinds } = this;

    const externalTransactionKind = this.externalTransactionKinds.length > 0 ? externalTransactionKinds[0] : null;

    this.actionType = externalTransactionKind ? switcher<ExternalTransactionKind, TransactionType|null>()
      .when(type => type.startsWith('DEPOSIT'), () => TransactionType.Deposit)
      .when(type => type.startsWith('WITHDRAW'), () => TransactionType.Withdrawal)
      .when(type => type.startsWith('BET'), () => TransactionType.Bet)
      .none(type => {
        console.error('[TRANSACTION_TYPE] not identified', { type });
        return null;
      })
      .match(externalTransactionKind as ExternalTransactionKind) : null;

    if (this.fromActiveConversation) {
      this.currentStep = StepRoute['ContactOptions'];
      return;
    }

    // means we returned to this page from overloaded error
    if (this.showThresholdLimitModal) {
      this.currentStep = StepRoute['ContactOptions'];
      return;
    }

    // Only NOT resolved will go to RuleEnginHelper
    if (this.isLogin) {
      this.resolveTransactionStep();
    } else {
      if (!this.isLogin) {
        listenFromParent('LOGIN_POP', (data: { isLogin: boolean, token: string }) => {
          if (this.currentStep === StepRoute['LoginGuest']) {
            this.updateLoginStatus(data);

            this.handleLogin();
          }
        });
        this.currentStep = StepRoute['LoginGuest'];
      } else {
        if (!this.actionType) {
          if (this.connectConfig?.showDescriptionBox) {
            this.currentStep = StepRoute['LoggedInForm'];
          } else {
            this.currentStep = StepRoute['ContactOptions'];
          }

          return;
        }
        this.currentStep = StepRoute['Transaction'];
      }
    }
    // TODO: [voice dev]
    // this.currentStep = StepRoute['ContactOptions'];
  }

  resolveTransactionStep () {
    if (this.fromActiveConversation) {
      this.currentStep = StepRoute.ContactOptions;
      return;
    }

    if (!this.connectConfig?.appliedMetadataAutomation && this.actionType) {
      this.currentStep = StepRoute['Transaction'];
    } else {
      // AI TODO: maybe remove this condition and set subject if it's empty
      if (this.connectConfig?.appliedMetadataAutomation || this.connectConfig?.aiConversation) {
        // with applied metadata automation we should have this data
        this.requestInfo.subject = this.ticketSubject;
      }

      if (this.connectConfig?.showDescriptionBox) {
        this.currentStep = StepRoute['LoggedInForm'];
      } else {
        this.currentStep = StepRoute['ContactOptions'];
      }
    }
  }

  @Watch('currentStep')
  onStepChange (step: StepRoute, previous: StepRoute) {
    this.prevStep = previous;
    this.$emit('step:changed', { step, previous } as StepChangeEvent);
  }

  updated () {
    this.$emit('updated');
  }

  /**
   * @event GuestForm#submit:detail
   */
  onSubmitGuestForm ($event: VisitorInfoFilled) {
    const { visitorInfo, description } = $event;
    this.guestDescription = description;

    this.requestInfo.subject = this.ticketSubject;
    this.requestInfo.description = description;
    this.requestInfo.email = visitorInfo.email;

    this.savedDataToPass.guest = $event;

    this.$emit('visitor:info', $event);
    this.currentStep = StepRoute['ContactOptions'];
  }

  /**
   * @event ContactOption#connect:request
   */
  handleContactOption ($event: ConnectRequestEvent) {
    this.$emit('connect:request', $event);
    if ($event.type === 'openRequest') {
      this.currentStep = StepRoute['OpenRequestEnd'];
    }
  }

  handleBackLogin () {
    this.currentStep = StepRoute['Transaction'];
  }

  handleBackContactOptions () {
    this.currentStep = this.prevStep;
  }

  endChat () {
    this.$emit('endChat');
  }

  // Login
  handleLogin () {
    this.$emit('login:successful');
    this.resolveTransactionStep();
  }

  handleTransactionInput ($event: TransactionInputEvent) {
    this.savedDataToPass.transactions = $event;
    this.requestInfo.subject = this.ticketSubject;
    this.$emit('transaction:input', $event);

    if (this.connectConfig?.showDescriptionBox || $event.selectedTransIssue.length === 0) {
      this.currentStep = StepRoute['LoggedInForm'];
    } else {
      this.currentStep = StepRoute['ContactOptions'];
    }
  }

  handleRemedyTransactionInput ($event: RemedyTransactionInputEvent) {
    this.$emit('remedy-transaction:input', $event);
  }

  emitCancelSupportWithConfig () {
    this.$emit('support-request:cancel', this.connectConfig);
  }

  emitDirectOpenRequest (ticket: PleasedModel.TicketDetail) {
    this.$emit('direct-open-request', ticket);
  }

  emitOpenActiveConversation (conversation: Conversation) {
    this.currentStep = StepRoute['ContactOptions'];
    this.$emit('open-active-conversation', conversation);
  }

  // LoggedInForm
  handleLoggedInform (data: VisitorInfoFilled & DynamicFieldData) {
    const { visitorInfo, description = '', fields } = data;

    this.fieldData = { fields };

    this.requestInfo.subject = this.ticketSubject;
    this.requestInfo.description = description;
    this.requestInfo.email = visitorInfo.email;

    this.savedDataToPass.loggedInForm = { visitorInfo, description };

    this.$emit('visitor:info', { visitorInfo, description });
    this.currentStep = StepRoute['ContactOptions'];
  }

  updateRequestInfo (requestInfo: { subject: string, description: string, email: string }) {
    this.requestInfo = { ...requestInfo };
  }

  handleLoggedInRequestEnd (button: Button) {
    if (button.id === buttonKeyMap.End) {
      this.endChat();
    } else {
      emitOpenMyRequest(true);
    }
  }

  setShowThresholdLimitModal (show: boolean) {
    this.$emit('set-show-threshold-limit-modal', show);
  }

  handleTransactionWithMetadataRuleApplied (data: { transactionEvent: TransactionInputEvent, metadataEvent: ApplyMetadataAutomationExternEvent}) {
    const { transactionEvent, metadataEvent } = data;

    this.handleTransactionInput(transactionEvent);
    this.$emit('metadata-rule-applied', metadataEvent);
  }

  showOverlayTrigger (match: MatchedChatTrigger) {
    this.$emit('show-overlay-trigger', match);
  }
}
